/** #294: second line of a picker row — the caller's subtitle plus an "Archived" marker for archived chats. */
export function contactRowSubtitle(
    contact: { archived?: boolean } | null | undefined,
    subtitle: string | undefined,
    archivedLabel: string,
): string | undefined {
    if (contact?.archived !== true) return subtitle;
    return [subtitle, archivedLabel].filter(Boolean).join(' · ');
}
